module.exports = __webpack_public_path__ + "static/contribution_img6_on@2x-970912e79f793af3f60e9111d7229ca6.jpg";